import * as yup from "yup"
import { validateField, validateFields } from "src/modules/validation"
import { SELECT_OTHER } from "src/modules/const"

export const validateGeneralInformation = async (
  firstName: string,
  lastName: string,
  firstNameJP: string,
  lastNameJP: string,
  birthday: string,
  phoneNumber: string,
  postcode: string,
  city: string,
  setNameValidationMessage: any,
  setBirthdayValidationMessage: any,
  setPhoneNumberValidationMessage: any,
  setPostCodeValidationMessage: any,
  setCityValidationMessage: any,
  translation: any
) => {
  const t = translation

  let validation = true
  try {
    await validateFields(
      yup.object().shape({
        firstName: yup.string().required(t("please_input_first_name")),
        lastName: yup.string().required(t("please_input_last_name")),
        firstNameJP: yup
          .string()
          .required(t("please_input_first_name_jp"))
          .matches(/^[ァ-ヶｱ-ﾝﾞﾟ一-]*$/, t("please_input_jp_string")),
        lastNameJP: yup
          .string()
          .required(t("please_input_last_name_jp"))
          .matches(/^[ァ-ヶｱ-ﾝﾞﾟ一-]*$/, t("please_input_jp_string")),
      }),
      ["firstName", "lastName", "firstNameJP", "lastNameJP"],
      [firstName, lastName, firstNameJP, lastNameJP]
    )
    validation = validation && true
    setNameValidationMessage("")
  } catch (err: any) {
    setNameValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        birthday: yup
          .string()
          .required(t("please_input_birthday"))
          .matches(/^(\d{4})\-(\d{1,2})\-(\d{1,2})$/, t("please_input_correct_birthday")),
      }),
      "birthday",
      birthday
    )
    setBirthdayValidationMessage("")
  } catch (err: any) {
    setBirthdayValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        phoneNumber: yup
          .string()
          .required(t("please_input_phone_number"))
          .matches(
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
            t("please_input_correct_phone_number")
          ),
      }),
      "phoneNumber",
      phoneNumber
    )
    setPhoneNumberValidationMessage("")
  } catch (err: any) {
    setPhoneNumberValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        postcode: yup
          .string()
          .required(t("please_input_post_code"))
          .matches(/〒?[0-9]{3}-?[0-9]{4}/g, t("please_input_correct_post_code")),
      }),
      "postcode",
      postcode
    )
    setPostCodeValidationMessage("")
  } catch (err: any) {
    setPostCodeValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        city: yup.string().required(t("please_input_city")),
      }),
      "city",
      city
    )
    setCityValidationMessage("")
  } catch (err: any) {
    setCityValidationMessage(err.message)
    validation = validation && false
  }

  return validation
}

export const validateLoginInformation = async (
  email: string,
  password: string,
  passwordConfirm: string,
  setEmailValidationMessage: any,
  setPasswordValidationMessage: any,
  setPasswordConfirmValidationMessage: any,
  magazinRegister: boolean | undefined,
  setMagazinValidationMessage: any,
  startStageID: number | undefined,
  setStartStageIDValidationMessage: any,
  startPlanID: number | undefined,
  setStartPlanIDValidationMessage: any,
  translation: any
) => {
  let t = translation
  let validation = true

  try {
    await validateField(
      yup.object().shape({
        email: yup
          .string()
          .required(t("please_input_email"))
          .email(t("please_input_correct_email")),
      }),
      "email",
      email
    )
    setEmailValidationMessage("")
  } catch (err: any) {
    setEmailValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        password: yup
          .string()
          .required(t("please_input_password"))
          .min(8, t("password_length_min"))
          .max(20, t("password_length_max"))
          .test("isValidPassword", t("password_regex"), (value) => {
            const hasLowerCase = /[a-z]/.test(value)
            const hasNumber = /[0-9]/.test(value)

            return hasLowerCase && hasNumber
          }),
      }),
      "password",
      password
    )
    setPasswordValidationMessage("")
  } catch (err: any) {
    setPasswordValidationMessage(err.message)
    validation = validation && false
  }

  if (password === passwordConfirm) {
    setPasswordConfirmValidationMessage("")
  } else {
    setPasswordConfirmValidationMessage(t("password_password_confirm_different"))
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        magazineRegister: yup.boolean().required(t("please_select_magazin_register")),
      }),
      "magazineRegister",
      magazinRegister
    )
    setMagazinValidationMessage("")
  } catch (err: any) {
    setMagazinValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        startStageID: yup.number().required(t("please_select_stage")),
      }),
      "startStageID",
      startStageID
    )
    setStartStageIDValidationMessage("")
  } catch (err: any) {
    setStartStageIDValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        startPlanID: yup.number().required(t("please_select_plan")),
      }),
      "startPlanID",
      startPlanID
    )
    setStartPlanIDValidationMessage("")
  } catch (err: any) {
    setStartPlanIDValidationMessage(err.message)
    validation = validation && false
  }
  return validation
}

export const validateCompanyInformation = async (
  startDate: string | undefined,
  setStartDateValidationMessage: any,
  siteURL: string | undefined,
  setSiteURLValidationMessage: any,
  route: number | undefined,
  routeComment: string | undefined,
  setRouteValidationMessage: any,
  companyType: number | undefined,
  setCompanyTypeValidationMessage: any,
  lounge: boolean | undefined,
  setLoungeValidationMessage: any,
  translation: any
) => {
  let t = translation
  let validation = true

  try {
    if (startDate) {
      await validateField(
        yup.object().shape({
          startDate: yup
            .string()
            .matches(/^(\d{4})\-(\d{1,2})\-(\d{1,2})$/, t("please_input_correct_start_date")),
        }),
        "startDate",
        startDate
      )
    }
    setStartDateValidationMessage("")
  } catch (err: any) {
    setStartDateValidationMessage(err.message)
    validation = validation && false
  }

  try {
    if (siteURL) {
      await validateField(
        yup.object().shape({
          siteURL: yup
            .string()
            .matches(
              /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
              t("please_input_correct_site_url")
            ),
        }),
        "siteURL",
        siteURL
      )
    }
    setSiteURLValidationMessage("")
  } catch (err: any) {
    setSiteURLValidationMessage(err.message)
    validation = validation && false
  }

  try {
    await validateField(
      yup.object().shape({
        route: yup.number().required(t("please_select_route")),
      }),
      "route",
      route
    )
    setRouteValidationMessage("")
  } catch (err: any) {
    setRouteValidationMessage(err.message)
    validation = validation && false
  }

  if (route === SELECT_OTHER) {
    if (!routeComment) {
      setRouteValidationMessage(t("please_input_route"))
      validation = validation && false
    }
  }

  try {
    await validateField(
      yup.object().shape({
        companyType: yup.number().required(t("please_select_company_type")),
      }),
      "companyType",
      companyType
    )
    setCompanyTypeValidationMessage("")
  } catch (err: any) {
    setCompanyTypeValidationMessage(err.message)
    validation = validation && false
  }

  if (lounge === undefined) {
    setLoungeValidationMessage(t("please_select_lounge"))
    validation = validation && false
  } else {
    setLoungeValidationMessage("")
  }

  return validation
}
